import { Typography } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { StyledContainerCentered } from '../../styles/ContainerStyles'

const Message = ({ children }: PropsWithChildren) => {
  return (
    <StyledContainerCentered>
      <Typography variant="body1" color="text.light" sx={{ fontStyle: 'italic', fontSize: '1rem' }}>
        {children}
      </Typography>
    </StyledContainerCentered>
  )
}

export default Message
